import { freeze, assign } from 'icepick';
import type { EditableComponent } from '../../../common/model/types.tsx';
import {
	INITIATE_UPDATE_COMPONENT,
	INITIATE_UPDATE_COMPONENT_SUCCESS,
	INITIATE_UPDATE_COMPONENT_FAIL,
	UPDATE_COMPONENT_REQUEST,
	UPDATE_COMPONENT_SUCCESS,
	UPDATE_COMPONENT_VALIDATION_FAIL,
	UPDATE_COMPONENT_FAIL,
	type InitiateUpdateComponentAction,
	type InitiateUpdateComponentSuccessAction,
	type InitiateUpdateComponentFailAction,
	type UpdateComponentRequestAction,
	type UpdateComponentSuccessAction,
	type UpdateComponentValidationFailAction,
	type UpdateComponentFailAction,
} from '../../actions.tsx';
import {
	UPDATE_EDITED_COMPONENT,
	CANCEL,
	type UpdateEditedComponentAction,
	type CancelAction,
} from './actions.tsx';

export type EditState = {
	saveIsInProgress: boolean;
	id?: string;
	editedComponent?: EditableComponent;
	nameErrorMessage?: string;
	leadErrorMessage?: string;
	initialiseInProgress: boolean;
};

type Action =
	| InitiateUpdateComponentAction
	| InitiateUpdateComponentSuccessAction
	| InitiateUpdateComponentFailAction
	| UpdateEditedComponentAction
	| CancelAction
	| UpdateComponentRequestAction
	| UpdateComponentSuccessAction
	| UpdateComponentValidationFailAction
	| UpdateComponentFailAction;

export const initialState: EditState = freeze({
	saveIsInProgress: false,
	initialiseInProgress: false,
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: EditState = initialState, action: Action): EditState => {
	switch (action.type) {
		case INITIATE_UPDATE_COMPONENT: {
			return freeze({
				initialiseInProgress: true,
				id: action.payload.id,
				saveIsInProgress: false,
			});
		}

		case INITIATE_UPDATE_COMPONENT_SUCCESS: {
			return assign(state, {
				initialiseInProgress: false,
				id: action.payload.id,
				editedComponent: action.payload.component,
				saveIsInProgress: false,
			});
		}

		case INITIATE_UPDATE_COMPONENT_FAIL: {
			return assign(state, {
				initialiseInProgress: false,
				id: undefined,
				editedComponent: false,
				saveIsInProgress: false,
			});
		}

		case UPDATE_EDITED_COMPONENT: {
			return assign(state, {
				editedComponent: action.payload.component,
			});
		}

		case CANCEL: {
			return assign(state, {
				id: undefined,
				editedComponent: undefined,
				saveIsInProgress: false,
			});
		}

		case UPDATE_COMPONENT_REQUEST: {
			return assign(state, {
				saveIsInProgress: true,
				nameErrorMessage: undefined,
				leadErrorMessage: undefined,
			});
		}

		case UPDATE_COMPONENT_SUCCESS: {
			return assign(state, {
				saveIsInProgress: false,
				id: undefined,
				editedComponent: undefined,
			});
		}

		case UPDATE_COMPONENT_VALIDATION_FAIL: {
			return assign(state, {
				nameErrorMessage: action.payload.errors.name,
				leadErrorMessage: action.payload.errors.componentLead,
				saveIsInProgress: false,
			});
		}

		case UPDATE_COMPONENT_FAIL: {
			return assign(state, {
				saveIsInProgress: false,
			});
		}

		default:
			return state;
	}
};
